import React from 'react';
import PropTypes from 'prop-types';
import { Color, SunrunThemeProvider } from '@sunrun/mui-theme';
import { SECONDARY_COLOR } from './components/general/constants/_colors';
// overrides for every single style injected by Material-UI into the DOM
// used for common elements like buttons, form elements, etc.

const overrides = {
  typography: {
    fontFamily: '"Roobert", sans-serif',
    body2: {
      fontFamily: '"Roobert", sans-serif',
    },
    body1: {
      fontFamily: '"Roobert", sans-serif',
    },
    h2: { fontFamily: '"Roobert", sans-serif' },
    h3: { fontFamily: '"Roobert", sans-serif' },
    h4: { fontFamily: '"Roobert", sans-serif' },
    h5: { fontFamily: '"Roobert", sans-serif' },
    h6: { fontFamily: '"Roobert", sans-serif' },
    subtitle1: { fontFamily: '"Roobert", sans-serif' },
    subtitle2: { fontFamily: '"Roobert", sans-serif' },
    button: { fontFamily: '"Roobert", sans-serif' },
    caption: { fontFamily: '"Roobert", sans-serif' },
    overline: { fontFamily: '"Roobert", sans-serif' },
  },
  MuiOutlinedInput: {
    root: {
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: SECONDARY_COLOR,
      },
    },
  },
  MuiFormLabel: {
    root: {
      '&:focused': {
        color: SECONDARY_COLOR,
      },
    },
  },
  MuiButton: {
    containedPrimary: {
      color: Color.WHITE,
      backgroundColor: SECONDARY_COLOR,
      textTransform: 'none',
      marginTop: '35px',

      '&:hover': {
        backgroundColor: '#006EE6',
      },
    },
  },
  MuiTableRow: {
    hover: {
      '&:hover': {
        transform: 'scale(1)',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.45)',
        cursor: 'pointer',
      },
    },
  },
};

const MaterialUITheme = ({ children }) => <SunrunThemeProvider themeOverrides={overrides}>{children}</SunrunThemeProvider>;

MaterialUITheme.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MaterialUITheme;
